import PraisoServices from "./PraisoServices";
import { getToken } from "./LocalStorageService";

export const AdminGetGroupAPI = async (groupId: number) => {
  const ApiUrl = `groups/${groupId}`;
  const token = getToken();
  try {
    const response = await PraisoServices(
      ApiUrl,
      "get",
      {},
      {},
      {
        Authorization: `Bearer ${token}`,
      }
    );
    try {
      return response;
    } catch (error) {
      const err = error as Error;
      return {
        status: {
          code: 1,
          message: err?.message,
        },
        content: null,
      };
    }
  } catch (error_1) {
    const err = error_1 as Error;
    return {
      status: {
        code: 1,
        message: err.message,
      },
      content: null,
    };
  }
};


export const AdminGetGroupHierarchyAPI = async (loggedInUserId) => {
  const ApiUrl = `groups/v1/get-group-hierarchy/${loggedInUserId}`;
  const token = getToken();
  try {
    const response = await PraisoServices(
      ApiUrl,
      "get",
      {},
      {},
      {
        Authorization: `Bearer ${token}`,
      }
    );
    try {
      return response;
    } catch (error) {
      const err = error as Error;
      return {
        status: {
          code: 1,
          message: err?.message,
        },
        content: null,
      };
    }
  } catch (error_1) {
    const err = error_1 as Error;
    return {
      status: {
        code: 1,
        message: err.message,
      },
      content: null,
    };
  }
};

export const AdminUpsertGroupApi = async (groupData) => {
  window.localStorage.removeItem("API");
  const ApiUrl = `groups`;
  const token = getToken();
  try {
    const response = await PraisoServices(
      ApiUrl,
      "post",
      {
        ...groupData,
      },
      {},
      {
        Authorization: `Bearer ${token}`,
      }
    );
    try {
      return response;
    } catch (error) {
      const err = error as Error;
      return {
        status: {
          code: 1,
          message: err?.message,
        },
        content: null,
      };
    }
  } catch (error_1) {
    const err = error_1 as Error;
    return {
      status: {
        code: 1,
        message: err.message,
      },
      content: null,
    };
  }
};

export const AdminGetProviderAPI = async (groupId?:any) => {
  // const ApiUrl = `providers/search?groupId=${groupId}`;
  const ApiUrl = `providers/search`;
  const token = getToken();
  try {
    const response = await PraisoServices(
      ApiUrl,
      "get",
      {},
      {},
      {
        Authorization: `Bearer ${token}`,
      }
    );
    try {
      return response;
    } catch (error) {
      const err = error as Error;
      return {
        status: {
          code: 1,
          message: err?.message,
        },
        content: null,
      };
    }
  } catch (error_1) {
    const err = error_1 as Error;
    return {
      status: {
        code: 1,
        message: err.message,
      },
      content: null,
    };
  }
};

export const adminGetGroup = async (groupId) => {
  const data = await AdminGetGroupAPI(groupId);
  return data;
  // if (
  //   data.status.code !== 0 &&
  //   data.status.code !== 200 &&
  //   data.status.code !== 201
  // ) {
  //   return data;
  // } else {
  //   return data;
  // }
};


export const adminGetGroupHierarchy = async (loggedInUserId) => {
  const data = await AdminGetGroupHierarchyAPI(loggedInUserId);
  return data;
  // if (
  //   data.status.code !== 0 &&
  //   data.status.code !== 200 &&
  //   data.status.code !== 201
  // ) {
  //   return data;
  // } else {
  //   return data;
  // }
};

export const adminUpsertGroup = async (groupData) => {
  const data = await AdminUpsertGroupApi(groupData);
  // if (
  //   data.status.code !== 0 &&
  //   data.status.code !== 200 &&
  //   data.status.code !== 201
  // ) {
  //   return data;
  // } else {
  //   return data;
  // }
  return data;
};

export const adminGetProvider = async (groupId?:any) => {
  // const data = await AdminGetProviderAPI(groupId);
  const data = await AdminGetProviderAPI();
  return data;
  // if (
  //   data.status.code !== 0 &&
  //   data.status.code !== 200 &&
  //   data.status.code !== 201
  // ) {
  //   return data;
  // } else {
  //   return data;
  // }
};